import React, { useEffect, useRef, useState, useContext } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Sidebar.scss';
import { UserContext } from '../../contexts/UserContext';

import Logo from '../../assets/images/logo.png'
import HomeIcon from '../../assets/images/Icon.png';
import TicketTrackingIcon from '../../assets/images/Icon.png';
import CSATIcon from '../../assets/images/Icon.png';
import PerformancesIcon from '../../assets/images/Icon.png';
import MEE6DashboardIcon from '../../assets/images/Icon.png';
import LogoutIcon from '../../assets/images/Icon.png';
import OptionsIcon from '../../assets/images/options.png';

const sidebarNavItems = [
  {
    display: 'Home',
    icon: <img src={HomeIcon} alt='Home' />,
    to: '/',
    section: '',
    showWhenLoggedIn: true,
    minFlag: 1,
  },
  {
    display: 'Login',
    icon: <img src={LogoutIcon} alt='Login' />,
    to: '/login',
    section: 'logout',
    showWhenLoggedOut: true,
  },
  {
    display: 'Ticket Tracking',
    icon: <img src={TicketTrackingIcon} alt='Ticket Tracking' />,
    to: '/ticket-tracking',
    section: 'ticket-tracking',
    showWhenLoggedIn: true,
    minFlag: 4,
    category: 'Staff Tools',
  },
  {
    display: 'Productivity',
    icon: <img src={PerformancesIcon} alt='Productivity' />,
    to: '/productivity',
    section: 'productivity',
    showWhenLoggedIn: true,
    minFlag: 4,
    category: 'Staff Tools',
  },
  {
    display: 'CSAT',
    icon: <img src={CSATIcon} alt='CSAT' />,
    to: '/csat',
    section: 'csat',
    showWhenLoggedIn: true,
    minFlag: 4,
    category: 'Staff Tools',
  },
  {
    display: 'Refund Tracking',
    icon: <img src={TicketTrackingIcon} alt='Refund Tracking' />,
    to: '/refund-tracking',
    section: 'refund-tracking',
    showWhenLoggedIn: true,
    minFlag: 4,
    category: 'Staff Tools',
  },
  {
    display: 'Personal Productivity',
    icon: <img src={PerformancesIcon} alt='Productivity' />,
    to: `/personal-productivity`,
    section: 'personal-productivity',
    showWhenLoggedIn: true,
    minFlag: 3,
    category: 'Personal Tools',
  },
  {
    display: 'Personal CSAT',
    icon: <img src={PerformancesIcon} alt='Personal CSAT' />,
    to: `/personal-csat`,
    section: 'personal-csat',
    showWhenLoggedIn: true,
    minFlag: 3,
    category: 'Personal Tools',
  },
  {
    display: 'MEE6 Dashboard',
    icon: <img src={MEE6DashboardIcon} alt='MEE6 Dashboard' />,
    to: '/mee6-dashboard',
    section: 'mee6-dashboard',
    showWhenLoggedIn: true,
    minFlag: 5,
    category: 'Admin Tools',
  },
  {
    display: 'URL Shortener',
    icon: <img src={LogoutIcon} alt='URL Shortener' />,
    to: '/url-shortener',
    section: 'url-shortener',
    showWhenLoggedIn: true,
    minFlag: 2,
    category: 'Utils',
  },
  {
    display: 'Logout',
    icon: <img src={LogoutIcon} alt='Logout' />,
    to: '/logout',
    section: 'logout',
    showWhenLoggedIn: true,
    minFlag: 0,
    category: 'Utils',
  },
];


const Dropdown = ({ open, children }) => {
  if (!open) {
    return null;
  }
  return <div className="sidebar__user__dropdown">{children}</div>;
};

const Sidebar = () => {
  const { user, updateUser } = useContext(UserContext);
  const [activeSection, setActiveSection] = useState('');
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const sidebarRef = useRef();
  const location = useLocation();

  const useOutsideClick = (ref, callback) => {
    const handleClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        callback();
      }
    };

    useEffect(() => {
      document.addEventListener('click', handleClick);

      return () => {
        document.removeEventListener('click', handleClick);
      };
    });
  };

  useEffect(() => {
    const curPath = location.pathname.split('/')[1];
    setActiveSection(curPath);
  }, [location]);

  useEffect(() => {
    updateUser();
  }, [updateUser]);

const getCategoryItems = (category) => {
  return sidebarNavItems.filter((item) => {
    // Check if the item is meant to be shown when the user is logged in
    if (item.showWhenLoggedIn && !user) {
      return false;
    }

    // Check if the item is meant to be shown when the user is logged out
    if (item.showWhenLoggedOut && user) {
      return false;
    }

    // Check if the user's flag is equal to or greater than the item's minimum flag
    if (user?.flag < item.minFlag) {
      return false;
    }

    // If all checks pass, return the item
    return item.category === category;
  });
};

  const handleOptionsClick = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const handleOutsideClick = () => {
    setIsDropdownOpen(false);
  };

  useOutsideClick(sidebarRef, handleOutsideClick);

  return (
    <div className="sidebar" ref={sidebarRef}>
      <div className="sidebar__logo"><img src={Logo} alt='Isha' /></div>
      {/* <div className="sidebar__logo">Isha</div> */}

      <div className="sidebar__menu">
        <Link to="/" key="home">
          <div className={`sidebar__menu__item ${activeSection === '' ? 'active' : ''}`}>
            <div className="sidebar__menu__item__icon">{sidebarNavItems[0].icon}</div>
            <div className="sidebar__menu__item__text">{sidebarNavItems[0].display}</div>
          </div>
        </Link>
        {!user && (
          <Link to="/login" key="login">
            <div className={`sidebar__menu__item ${activeSection === 'login' ? 'active' : ''}`}>
              <div className="sidebar__menu__item__icon"><img src={LogoutIcon} alt='Login' /></div>
              <div className="sidebar__menu__item__text">Login</div>
            </div>
          </Link>
        )}
        {['Staff Tools', 'Personal Tools', 'Admin Tools', 'Utils'].map((category) => {
          const categoryItems = getCategoryItems(category);
          if (categoryItems.length === 0) {
            return null;
          }
          return (
            <React.Fragment key={category}>
              <div className="sidebar__menu__category">{category}</div>
              {categoryItems.map((item, index) => (
                <Link to={item.to} key={index}>
                  <div
                    className={`sidebar__menu__item ${item.section === activeSection ? 'active' : ''}`}
                  >
                    <div className="sidebar__menu__item__icon">{item.icon}</div>
                    <div className="sidebar__menu__item__text">{item.display}</div>
                  </div>
                </Link>
              ))}
            </React.Fragment>
          );
        })}
      </div>
      <div className="sidebar__user">
        {user && (
          <div className="sidebar__user__info">
            <div className="sidebar__user__avatar">
              <img src={user.profilePicture} alt="Profile" />
            </div>
            <div className="sidebar__user__details">
              <div className="sidebar__user__username">{user.global_name}</div>
              <div className="sidebar__user__flag">Flag: {user.flag}</div>
            </div>
            <div className="sidebar__user__more">
              <button onClick={handleOptionsClick} className="sidebar__user__more__button">
                <img src={OptionsIcon} alt="Options" className="sidebar__user__more__icon" />
              </button>
              <Dropdown open={isDropdownOpen}>
                <div className="sidebar__user__more__menu">
                  <Link to="/logout" className="sidebar__user__more__menu__item">
                    Logout
                  </Link>
                </div>
              </Dropdown>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Sidebar;